export default __webpack_public_path__ + "static/media/setting.f7bdb3d2.svg";